export enum CurrencyCodeEnum {
  EUR = "€",
  DOL = "$",
}
